module.exports = __webpack_public_path__ + "static/media/menuSpeech.fdf3bf8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuSpeech.svg
// module id = 177
// module chunks = 0